import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsSprintComponent } from './simple-icons-sprint.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsSprintComponent ],
    exports:      [ SimpleIconsSprintComponent ],
    bootstrap:    []
})
export class SimpleIconsSprintModule {}
